import {scrollifyIsEnabled} from './media-query'
const url = 'https://jw6a3jtkq0.execute-api.eu-west-1.amazonaws.com/prod/digital-tact-contact-form';
const $cfName = $('#cf-name');
const $cfEmail = $('#cf-email');
const $cfMessage = $('#cf-message');
const $cfSubmit = $('#cf-submit');
const $loader = $('.loader');
const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var formData = {
    name: '',
    emailAddress: '',
    message: ''
};
var inputIsValid = true;
var isLoading = false;
var errorOccurred = false;

//Define callback for recaptcha
window.onSubmit = function (token) {
    submit(token);
};

$cfSubmit.click(function (event) {
    event.preventDefault();
    if (errorOccurred) {
        errorOccurred = false;
        $('.server-error-message').remove();
    }
    $cfSubmit.blur();
    if (!isLoading) {
        formData = {
            name: $cfName.val(),
            emailAddress: $cfEmail.val(),
            message: $cfMessage.val()
        };
        validateInput(formData);
        if (inputIsValid) {
            grecaptcha.execute();
        }
    }
});

function validateInput(formData) {
    if (!inputIsValid) {
        hideAllErrorMessages();
        inputIsValid = true;
    }
    if (formData.name === '') {
        showErrorMessage($cfName);
        inputIsValid = false;
    }
    if (formData.emailAddress === '') {
        showErrorMessage($cfEmail, 'Bitte ausfüllen');
        inputIsValid = false;
    } else if (!emailRegExp.test(formData.emailAddress)) {
        showErrorMessage($cfEmail, 'Bitte überprüfen');
        inputIsValid = false;
    }
    if (formData.message === '') {
        showErrorMessage($cfMessage);
        inputIsValid = false;
    }
}

function hideAllErrorMessages() {
    $('.error-message--visible').removeClass('error-message--visible')
}

function showErrorMessage(element, message) {
    if (message) {
        element.siblings().children('.error-message').text(message);
    }
    element.siblings().children('.error-message').addClass('error-message--visible');
}

function clearForm() {
    $cfName.val('');
    $cfEmail.val('');
    $cfMessage.val('');
}

function submit(token) {
    toggleLoadingState();
    const data = {
        name: formData.name,
        emailAddress: formData.emailAddress,
        message: formData.message,
        reCaptchaToken: token
    };

    $.ajax({
        type: 'POST',
        url: url,
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(data),
        success: function (res) {
            toggleLoadingState(res.success)
        },
        error: function () {
            toggleLoadingState(false)
        }
    });
}

function toggleLoadingState(success) {
    if (!isLoading) {
        isLoading = true;
        $cfSubmit.children('span').animate({
            opacity: 0
        }, 100).promise().done(function () {
            $cfSubmit.children('span').hide();
            $loader.show().animate({
                opacity: 1
            }, 250);
        });
    } else {
        if (success) {
            $loader.animate({
                opacity: 0
            }, 100).hide().promise().done(function () {
                clearForm();
                $cfSubmit.children('span').text('Vielen Dank').show().animate({
                    opacity: 1
                }, 250).promise().done(function () {
                    setTimeout(function () {
                        $cfSubmit.children('span').animate({
                            opacity: 0
                        }, 100).promise().done(
                          function () {
                              $cfSubmit.children('span').text('Senden').animate({
                                  opacity: 1
                              }, 250);
                              isLoading = false;
                              grecaptcha.reset();
                          }
                        )
                    }, 2500)
                });
            });
        } else {
            $loader.animate({
                opacity: 0
            }, 100).hide().promise().done(function () {
                $cfSubmit.children('span').show().animate({
                    opacity: 1
                }, 250);
                isLoading = false;
                grecaptcha.reset();
            });
            showServerErrorMessage('Es it ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.')
        }
    }
}

function showServerErrorMessage(textMessage) {
    errorOccurred = true;
    $('#cf-form').append('<p class="server-error-message">' + textMessage + '</p>')
    if (scrollifyIsEnabled) {
        $.scrollify.update();
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/js/contact-form.js
// module id = Q1JF
// module chunks = 0